import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { ResearchProject } from './ResearchProject'
import { loadData } from './ResearchProject.LoadData';

export default withOverrideLegacy(ResearchProject, loadData);